import { API_BASE_PATH } from '../../constants';

export const LOCALIZATION_URL = `${API_BASE_PATH}/localization/{locale}`;



// WEBPACK FOOTER //
// ./src/Shared/CustomIntlProvider/constants/index.js